import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'
import {addParamsToUrl, athubAxios} from "@/util";

const company = new RestResource({server: ORGANIZATION_SERVER, resource: 'company'});

company.invalidate = (id, athubConfig) => {
    return athubAxios.put([company.server, company.resource, id, 'invalid'].join('/'), null, athubConfig);
};

company.revalidate = (id, athubConfig) => {
    return athubAxios.put([company.server, company.resource, id, 'valid'].join('/'), null, athubConfig);
};

company.findByCode = (code, athubConfig) => {
    return athubAxios.get(addParamsToUrl([company.server, company.resource, 'code'].join('/'), {
        code: code
    }), athubConfig);
};

company.findByName = (name, athubConfig) => {
    return athubAxios.get(addParamsToUrl([company.server, company.resource, 'name'].join('/'), {
        name: name
    }), athubConfig);
};

export default company;